import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ManualServiceState } from '../../models/manual-service.models';

export const selectManualServicesState = createFeatureSelector<ManualServiceState>('manualService');

export const selectIsLoading = createSelector(
  selectManualServicesState,
  (state: ManualServiceState) => state.isLoading
);

export const selectManualServices = createSelector(
  selectManualServicesState,
  (state: ManualServiceState) => state.manualOrders
);

export const selectTotalItems = createSelector(
    selectManualServicesState,
    (state: ManualServiceState) => state.totalItems
);

export const selectTotalPages = createSelector(
    selectManualServicesState,
    (state: ManualServiceState) => state.totalPages
);

export const selectManualService = createSelector(
  selectManualServicesState,
  (state: ManualServiceState) => state.manualOrder
);

export const selectVehicleTypes = createSelector(
    selectManualServicesState,
    (state: ManualServiceState) => state.vehicleTypes
);

export const selectCalculatedRoute = createSelector(
    selectManualServicesState,
    (state: ManualServiceState) => state.calculatedOrderRoute
);

export const selectManualOrderById = (id: number) => createSelector(
  selectManualServicesState,
  (state: ManualServiceState) => {
    // Buscar en `orders`
    let order = state.manualOrders.find(order => order.id === id);

    // Retornar la orden encontrada o `undefined` si no existe
    return order;
  }
);
